module.exports = __webpack_public_path__ + "static/media/ScrollDownYellow.f46b52bc.svg";